class DmlVariantPickerItem extends HTMLElement {
  constructor() {
    super();
    this.elements = {};
    this.classes = {};
    this.isFirstElementOfType;
    this.aVariantHasBeenClicked = false;
    this.elements.thumbsHolder = this.closest('ul');
    this.elements.prodDetailOuter = this.closest('.product');
    this.elements.allVariantLinks = this.elements.prodDetailOuter.querySelector('dml-variant-picker-item');
    this.elements.bigImageHolder = this.elements.prodDetailOuter.querySelector('.product__dml-big-image');
    this.elements.loadingOverlay = this.querySelector('.loading-overlay');
    this.currentProductId = parseInt(this.elements.thumbsHolder.getAttribute('data-current-product-id'));
    this.currentProductLink = window.location.href;
    this.classes.thumbSelected = 'product__dml-thumb-selected';
    this.elements.link = this.querySelector('a');

    this.availableBlocks = [
      {
        blockName: 'title',
        templateIdPrefix: 'dml-pdp-block-title',
        selectorToChangeInner: 'product-info .product__title',
      },
      {
        blockName: 'highlighted',
        templateIdPrefix: 'dml-pdp-block-highlighted',
        selectorToChangeInner: 'product-info .dml-specifications__highlighted',
      },
      {
        blockName: 'designer',
        templateIdPrefix: 'dml-pdp-block-designer',
        selectorToChangeInner: 'product-info .product__designer',
      },
      {
        blockName: 'description',
        templateIdPrefix: 'dml-pdp-block-description',
        selectorToChangeInner: 'product-info .dml-specifications__description-holder',
      },
      {
        blockName: 'buy_buttons',
        templateIdPrefix: 'dml-pdp-block-buy-buttons',
        selectorToChangeInner: 'product-info .dml-specifications__buy-buttons-holder',
      },
      {
        blockName: 'dataProductJson',
        templateIdPrefix: 'dml-pdp-data-product-json',
        selectorToChangeInner: '#data-product-json-holder',
      },
    ];

    this.removeExtraBigImages();
    this.handleLink();
    this.handleFirstClick();
    this.handleHistory();
  }

  isInt(value) {
    return !isNaN(value) && parseInt(Number(value)) == value && !isNaN(parseInt(value, 10));
  }

  /**
   *
   * @param {int} loadFirstN, show the first N images. If empty or not an integer, load all
   */
  startLoadingImages(loadFirstN) {
    // make selection of big-image templates
    const bigImageTemplates = document.querySelectorAll('[id^="dml-pdp-big-image-"]:not([id^="dml-pdp-big-image-header"])');
    let imageMax = bigImageTemplates.length;
    if (this.isInt(loadFirstN)) {
      imageMax = parseInt(loadFirstN, 10);
    }
    for (let i = 0; i < imageMax; i++) {
      const bigImageTemplate = bigImageTemplates[i];
      const mediaGallery = bigImageTemplate.content.querySelector('media-gallery');
      if (mediaGallery.getAttribute('data-dml-image-loaded') === 'false') {
        const tempDiv = document.createElement('div');

        // set id on tempDiv so we can delete it again after image has loaded
        tempDiv.id = `tempDivMediaGallery-${i}`;

        // position tempDiv ouside of view
        tempDiv.style.position = 'absolute';
        tempDiv.style.left = '-9999px';

        // find width of future image container, so that we load image in right size
        const imageContainer = document.querySelector('.product__media');
        tempDiv.style.width = `${imageContainer.offsetWidth}px`;
        tempDiv.style.height = `${imageContainer.offsetHeight}px`;

        const newContent = bigImageTemplate.content.cloneNode(true);
        tempDiv.append(newContent);
        const img = tempDiv.querySelector('img');
        img.addEventListener('load', () => {
          this.setTemplateMediaGalleryLoadet(bigImageTemplate);
          document.getElementById(tempDiv.id).remove();
        });
        document.body.append(tempDiv);
      }
    }
  }

  handleFirstClick() {
    document.addEventListener('firstVariantClicked', () => {
      this.aVariantHasBeenClicked = true;
    });
  }

  handleLink() {
    this.elements.link.addEventListener('click', (e) => {
      this.switchVariants('clickLink', e);
    });
  }

  handleHistory() {
    // Listen for the popstate event
    window.addEventListener('popstate', (e) => {
      this.switchVariants('historyBackForward', e);
    });
  }

  switchVariants(why, e) {
    if (why && why === 'clickLink') {
      if (!this.aVariantHasBeenClicked) {
        this.startLoadingImages();
        document.dispatchEvent(new CustomEvent('firstVariantClicked'));
      }
      e.preventDefault();
      if (this.elements.link.classList.contains('product__dml-thumb-selected')) {
        return;
      }
    }

    this.setLoadingState(true);

    // change current id
    this.setCurrentProductIdAndLink(why, e);

    // change marking on chosen variant in thumbnails
    this.changeMarkingOnChosenVariantThumb();

    // change big image - remember animation
    this.changeBigImage();

    // change blocks in current section
    this.changeProductDetailBlocks();

    // change content in spec section
    this.changeSpecificationSection();

    //close any open product media modal
    const openProductModals = document.querySelectorAll('product-modal.product-media-modal--dml[open]');
    for (let i = 0; i < openProductModals.length; i++) {
      const openProductModal = openProductModals[i];
      openProductModal.hide();
    }

    if (why && why === 'clickLink') {
      // change url in address bar
      this.changeAddressBar();
    }
  }

  setLoadingState(loadingState) {
    if (loadingState) {
      //first remove all, if any should be left from before
      for (let i = 0; i < this.elements.allVariantLinks.length; i++) {
        const link = this.elements.allVariantLinks[i];
        link.classList.add('hidden');
      }
      // show spinner
      this.elements.loadingOverlay.classList.remove('hidden');
    } else {
      // hide spinner
      this.elements.loadingOverlay.classList.add('hidden');
    }
  }

  changeSpecificationSection() {
    const newTemplate = document.getElementById(`dml-pdp-block-specifications-${this.currentProductId}`);
    const elemToChangeInner = document.querySelector('.dml-specifications');
    if (newTemplate && elemToChangeInner) {
      const newContent = newTemplate.content.cloneNode(true);
      elemToChangeInner.innerHTML = '';
      elemToChangeInner.append(newContent);
    }
  }

  injectCSS(css) {
    const el = document.createElement('style');
    el.innerText = css;
    document.head.appendChild(el);
    return el;
  }

  changeProductDetailBlocks() {
    let transitionStyles = '';
    for (let i = 0; i < this.availableBlocks.length; i++) {
      this.availableBlocks[i].newContent = null;
      const block = this.availableBlocks[i];

      if (i > 0) {
        transitionStyles += ', ';
      }
      transitionStyles += block.selectorToChangeInner;

      const newTemplate = this.elements.prodDetailOuter.querySelector(`#${block.templateIdPrefix}-${this.currentProductId}`);
      const elemToChangeInner = this.elements.prodDetailOuter.querySelector(block.selectorToChangeInner);
      if (newTemplate && elemToChangeInner) {
        const newContent = newTemplate.content.cloneNode(true);
        this.availableBlocks[i].newContent = newContent;
        const productDetailBlocksEvent = (e) => {
          const cssObj = window.getComputedStyle(e.target, null);
          const currentOpacity = cssObj.getPropertyValue('opacity');
          if (currentOpacity === '0') {
            elemToChangeInner.innerHTML = '';
            elemToChangeInner.append(this.availableBlocks[i].newContent);
            elemToChangeInner.classList.remove('dml-fade-out-text');
          }
          document.removeEventListener('transitionend', productDetailBlocksEvent);
        };

        document.addEventListener('transitionend', productDetailBlocksEvent);

        elemToChangeInner.classList.add('dml-fade-out-text');
      }
    }

    transitionStyles += '{transition: opacity 0.3s;}';
    this.injectCSS(transitionStyles);
  }

  changeAddressBar() {
    // save product id and link to state, to be able to switch variant on history back or forward
    window.history.pushState({ prodId: this.currentProductId, prodLink: this.currentProductLink }, '', this.currentProductLink);
  }

  /**
   * so you don't have more than 2 big images no matter how many times you click a variant
   */
  removeExtraBigImages() {
    this.elements.bigImageHolder.addEventListener('animationend', () => {
      //delete elements that are not foreground or background (keep background since it keeps the height of the element)
      const secondToLastAndNotFirst = this.elements.bigImageHolder.querySelector('media-gallery:nth-child(2):nth-last-child(2)');
      if (secondToLastAndNotFirst) {
        secondToLastAndNotFirst.remove();
      }
    });
  }

  setTemplateMediaGalleryLoadet(template) {
    template.content.querySelector('media-gallery').setAttribute('data-dml-image-loaded', 'true');
  }

  changeBigImage() {
    // the image
    const newTemplate = this.elements.prodDetailOuter.querySelector(`#dml-pdp-big-image-${this.currentProductId}`);
    const newTemplateMediaGalleryTag = newTemplate.content.querySelector('media-gallery');
    const newContent = newTemplate.content.cloneNode(true);
    const newImg = newContent.querySelector('img');

    if (newTemplateMediaGalleryTag.getAttribute('data-dml-image-loaded') === 'false') {
      // do not add animation until image is loaded
      newImg.addEventListener('load', () => {
        newImg.closest('media-gallery').setAttribute('data-dml-image-loaded', 'true');
        this.setTemplateMediaGalleryLoadet(newTemplate);
        this.setLoadingState(false);
      });
    } else {
      // if image has been shown before already, just show it again
      this.setLoadingState(false);
    }
    this.elements.bigImageHolder.append(newContent);

    // the header, if any
    const newTemplate2 = this.elements.prodDetailOuter.querySelector(`#dml-pdp-big-image-header-${this.currentProductId}`);
    if (!newTemplate2) {
      return;
    }
    const newContent2 = newTemplate2.content.cloneNode(true);
    const headerHolder = this.elements.prodDetailOuter.querySelector('.product__dml-big-image-header');
    if (!headerHolder) {
      return;
    }
    headerHolder.innerHTML = '';
    headerHolder.append(newContent2);
  }

  setCurrentProductIdAndLink(why, e) {
    let prodId, prodLink;
    switch (why) {
      case 'clickLink':
        prodId = e.target.getAttribute('data-product-id');
        prodLink = e.target.href;
        break;

      case 'historyBackForward':
        if (e.state === null) {
          const origPageProduct = document.querySelector('.product__dml-thumb-origially-selected');
          prodId = origPageProduct.getAttribute('data-product-id');
          prodLink = origPageProduct.href;
        } else {
          prodId = e.state.prodId;
          prodLink = e.state.prodLink;
        }
        break;
    }

    this.currentProductId = prodId;
    this.currentProductLink = prodLink;
  }

  changeMarkingOnChosenVariantThumb() {
    // remove selected class from existing
    this.elements.thumbsHolder.querySelector(`.${this.classes.thumbSelected}`).classList.remove(this.classes.thumbSelected);

    // add selected class to new
    const newEl = this.elements.thumbsHolder.querySelector(`#dml-variant-picker-link-${this.currentProductId}`);
    newEl.classList.add(this.classes.thumbSelected);
  }
}
customElements.define('dml-variant-picker-item', DmlVariantPickerItem);

class DmlVariantPickerItemFirst extends DmlVariantPickerItem {
  constructor() {
    super();
    this.startLoadingImages(3);
  }
}
customElements.define('dml-variant-picker-item-first', DmlVariantPickerItemFirst);
